import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const PmiTitleDivider = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  color: theme.palette.secondary.main,
}));
